var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-message"},[_c('div',{staticClass:"system-message-header"},[_c('Icon',{attrs:{"name":_vm.iconClassEnum.REPLY_ARROW}}),_vm._v("\n    "+_vm._s(_vm.$t('messages.system_message_reply'))+"\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }